const RecommendationConfigActionTypes = {
  SET_CURRENT_LANGUAGE: 'SET_CURRENT_LANGUAGE',
  SET_RECOMMENDATION_RESULTS_LOADED: 'SET_RECOMMENDATION_RESULTS_LOADED'
};

export default RecommendationConfigActionTypes;
